"use strict";
(self["webpackChunkdev"] = self["webpackChunkdev"] || []).push([[5493],{

/***/ 5493:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ AccountPopup)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function AccountPopup({ wrapper }) {
  // Elements
  const $card = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-hook="account-popup-wrapper"]')

  // Data
  const formTypes = ['login', 'register', 'password'];

  ; (function init() {
    initEventListeners()
    watchURL()
  })()

  function initEventListeners() {

    formTypes.forEach((handle) => {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-hook="open-account-${handle}-popup"]`).on('click', function () {
        // Reset state

        // Open form
        revealPopup({ form: handle })
        findFirstFocusableElement({ form: handle })
      })
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).onClassChange('on', clearParamFromURL)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('popup:close', hidePopup);
  }

  function watchURL() {
    const urlParams = new URLSearchParams(window.location.search)

    if (urlParams.has('account-popup')) {
      if (urlParams.get('account-popup') == 'password-recovery-sent') {
        const $passwordForm = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-hook="popup-password"]')

        $passwordForm.find('[data-hook="success-message"]').addClass('on')
        $passwordForm.find('form[action="/account/recover"]').addClass('hidden')

        revealPopup({ form: 'password' })
        findFirstFocusableElement({ form: 'password' })
      }
    }
  }

  function findFirstFocusableElement({ form }) {
    const $activeform = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-hook="popup-${form}"]`)

    if ($activeform.hasClass('on')) {
      $activeform.find('.js-focus-first').trigger('focus');
    }
  }

  function hidePopup() {
    // Hide wrapper
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).removeClass('on')

    // Hide all forms
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-hook^="popup-"]').removeClass('on')

    // Hide overlay
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('overlay:hide')
  }

  function revealPopup({ form } = { form: 'login' }) {
    const $activeform = jquery__WEBPACK_IMPORTED_MODULE_0___default()(`[data-hook="popup-${form}"]`)
    const $inactiveForms = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-hook^="popup-"]').not($activeform)

    if (jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).is('.on')) {
      // Hide card
      $card.addClass('opacity-0')

      // Hide all forms
      $inactiveForms.removeClass('on')

      // Display correct form
      $activeform.addClass('on')

      // Reveal card
      $card.removeClass('opacity-0')

      // Hide Overlay
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('overlay:show')
    } else {
      // Hide all forms
      $inactiveForms.removeClass('on')

      // Display correct form
      $activeform.addClass('on')

      // Reveal card
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).addClass('on')

      // Show overlay
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('overlay:show')
    }
  }

  function clearParamFromURL() {
    const isOn = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).is('.on')

    if (!isOn) {
      const urlParams = new URLSearchParams(window.location.search)
      const newParams = urlParams.delete('account-popup')

      let newURL = window.location.pathname
      if (newParams) newURl += `?${newParams}`

      window.history.replaceState({}, '', newURL)

      // 
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-hook="open-account-login-popup"]:visible').trigger('focus')
    }
  }
}


/***/ })

}]);